import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

// menu item imports
import { alignToApplianceBottomMenuItem } from '../menu-item/align-to-appliance-bottom-menu-item';
import { appliancePropertiesMenuItem } from '../menu-item/appliance-properties-menu-item';
import { applyRulesMenuItem } from '../menu-item/apply-rules-menu-item';
import { centerVerticallyMenuItem } from '../menu-item/center-vertically-menu-item';
import { customAppliancePropertiesMenuItem } from '../menu-item/custom-appliance-properties-menu-item';
import { cutoutPropertiesMenuItem } from '../menu-item/cutout-properties-menu-item';
import { deleteApplianceMenuItem } from '../menu-item/delete-appliance-menu-item';
import { fullHeightMenuItem } from '../menu-item/full-height-menu-item';
import { islandPropertiesMenuItem } from '../menu-item/island-properties-menu-item';
import { lockPositionMenuItem } from '../menu-item/lock-position-menu-item';
import { swapApplianceMenuItem } from '../menu-item/swap-appliance-menu-item';

import { resetSkuColorMenuItem, skuColorMenuItem } from '../menu-item/sku-color-menu-item';

export const applianceMenuList: Array<ContextMenuList> = [
	swapApplianceMenuItem(),
	deleteApplianceMenuItem(),
	centerVerticallyMenuItem(),
	alignToApplianceBottomMenuItem(),
	lockPositionMenuItem(),
	applyRulesMenuItem(),
	{ type: ContextMenuListItemType.Divider, isVisible: ({ refMap }): boolean => refMap?.panelItem?.item.component.fullHeight === true },
	fullHeightMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	skuColorMenuItem(),
	resetSkuColorMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	appliancePropertiesMenuItem(),
	customAppliancePropertiesMenuItem(),
	cutoutPropertiesMenuItem(),
	islandPropertiesMenuItem()
];
